import React, { Component } from 'react'

// lib
import classnames from 'classnames'

// redux
import { connect } from 'react-redux'
import roleActions from '../../redux/qbrole/actions'

// ui
import Button from '../../components/uielements/button'
import { Input } from 'antd'

// icon
import { FaPlusCircle } from 'react-icons/fa'

const { Search } = Input

class Headbar extends Component {
    _handleAddClick = () => {
        this.props.setDefaultCurrentRole()
        this.props.showDetailModal()
    }

    render(){
        return (
            <div className={classnames('row', 'HeaderBar')}>
                <div>
                    <Button
                        type="primary"
                        onClick={() => this._handleAddClick()}
                    >
                        <FaPlusCircle className="iconButton" />
                        Thêm quyền người dùng
                    </Button>
                </div>
                <div>
                    {/* <Search
                        className="SearchBox"
                        placeholder="Nhập để tìm kiếm"
                        onSearch={value => console.log(value)}
                    /> */}
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showDetailModal: () => {
            dispatch(roleActions.action.showModalCurrentRoleInfo())
        },
        setDefaultCurrentRole: () => {
            dispatch(roleActions.action.setDefaultCurrentRole())
        }
    }
}

export default connect(null, mapDispatchToProps)(Headbar)